var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullbox"},[_c('div',{staticClass:"goback"},[_c('div',{on:{"click":_vm.goback}},[_c('i',{staticClass:"el-icon-arrow-left"}),_c('span',[_vm._v("返回")])])]),_c('div',{staticClass:"fullbox_table fullbox_table1"},[_c('pcTable',{attrs:{"tableData":_vm.tableSaleAll,"type":_vm.type}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }